module.exports = __webpack_public_path__ + "static/media/website.e16f0c8e.svg";